import { render, staticRenderFns } from "./TrendingPublishings.vue?vue&type=template&id=24f172c0&scoped=true"
import script from "./TrendingPublishings.vue?vue&type=script&lang=js"
export * from "./TrendingPublishings.vue?vue&type=script&lang=js"
import style0 from "./TrendingPublishings.vue?vue&type=style&index=0&id=24f172c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f172c0",
  null
  
)

export default component.exports